import React from "react";
import { clsx } from "clsx";
import PostTitle from "../components/PostTitle";
import PostEyecatch from "../components/PostEyecatch";
import PostContent from "../components/PostContent";
import PostBreadCrumbs from "./PostBreadCrumb";
import PostMetadata from "./PostMetadata";
import PostToC from "./PostToc";
import SnsShareBar from "./ShareSNSBar";
import { useSiteMetadata } from "../hooks/use-site-metadata";

interface IPostProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function Post(props: IPostProps) {
  const { siteUrl } = useSiteMetadata();
  const url = `${siteUrl}/posts/${props.post.postId}`;

  const { post } = props;
  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "items-center",
        "pb-6",
        "space-y-5",
        "w-full",
      )}
    >
      <PostBreadCrumbs post={post} />
      <PostTitle post={post} />
      <PostMetadata post={post} />
      <PostEyecatch post={post} />
      <PostToC post={post} />
      <PostContent post={post} />
      <SnsShareBar url={url} />
    </div>
  );
}
